var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"id":"hlsElement","width":"100%","height":"100%","controls":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"application/vnd.apple.mpegurl"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }